import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import productService from '../../services/productService';

// Thunk: fetch one page of products, replacing any previously loaded items
export const fetchProductsPage = createAsyncThunk(
    'products/fetchPage',
    async ({ page = 0, size = 10, search = '' }, { rejectWithValue }) => {
        try {
            return await productService.getProductsPaginated(page, size, search);
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Failed to load products');
        }
    }
);

const productsSlice = createSlice({
    name: 'products',
    initialState: {
        items: [],          // products on the CURRENT page only
        totalElements: 0,
        totalPages: 0,
        currentPage: 0,
        pageSize: 10,
        search: '',
        loading: false,
        error: null,
    },
    reducers: {
        setSearch(state, action) {
            state.search = action.payload;
            state.currentPage = 0;  // reset to first page on new search
        },
        setPageSize(state, action) {
            state.pageSize = action.payload;
            state.currentPage = 0;
        },
        clearProducts(state) {
            state.items = [];
            state.totalElements = 0;
            state.totalPages = 0;
            state.currentPage = 0;
            state.search = '';
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductsPage.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProductsPage.fulfilled, (state, action) => {
                state.loading = false;
                // Replace items — previous page items are discarded
                state.items = action.payload.content;
                state.totalElements = action.payload.totalElements;
                state.totalPages = action.payload.totalPages;
                state.currentPage = action.payload.page;
                state.pageSize = action.payload.size;
            })
            .addCase(fetchProductsPage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.items = [];
            });
    },
});

export const { setSearch, setPageSize, clearProducts } = productsSlice.actions;
export default productsSlice.reducer;
